import { HttpErrorResponse } from '@angular/common/http';
import { BoardCompany } from '../board-v3.types';

const COMPANY_ERROR_KEYS: Record<string, string> = {
  COMPANY_V2_NOT_FOUND: 'board_v3_company_error_not_found',
  COLUMN_CARD_NOT_FOUND: 'board_v3_contact_error_card_not_found',
  PHONE_NUMBER_INVALID: 'board_v3_contact_error_phone_invalid',
  EMAIL_INVALID: 'board_v3_contact_error_email_invalid',
  ADDRESS_INVALID: 'board_v3_contact_error_address_invalid',
};

export function getCompanyName(company: Pick<BoardCompany, 'name'> | null | undefined): string {
  return (company?.name ?? '').trim();
}

export function getCompanyPhones(company: BoardCompany): string[] {
  return (company.phones ?? []).map((phone) => phone.number_e164).filter(Boolean);
}

export function getCompanyEmails(company: BoardCompany): string[] {
  return (company.emails ?? []).map((email) => email.email).filter(Boolean);
}

/** Translation key for a company API error */
export function getCompanyErrorKey(error: unknown): string {
  const code = (error as HttpErrorResponse)?.error?.errors?.[0]?.code as string | undefined;
  return (code && COMPANY_ERROR_KEYS[code]) || 'errors.default_error';
}
